/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Pause = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "4", height: "16", x: "6", y: "4" }],
    ["rect", { width: "4", height: "16", x: "14", y: "4" }]
  ]
];

export { Pause as default };
//# sourceMappingURL=pause.js.map
